<app-manually-uploaded-consult-notes [disableEhrToggles]="false" />

